import { render } from "./form.vue?vue&type=template&id=768ce674&scoped=true&ts=true"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"

import "./form.vue?vue&type=style&index=0&id=768ce674&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768ce674"]])

export default __exports__